export const statusColor = {
  potential: '#7f5dff',
  new: '#EE4266',
  'application-sent': '#AA7FC2',
  'application-received': '#0099CC',
  waitlisted: '#7BCAD2',
  accepted: '#99CC00',
  archived: '#adb1bd',
};
